import { render, staticRenderFns } from "./LandingGeboortelijst.vue?vue&type=template&id=b61b6e38"
import script from "./LandingGeboortelijst.vue?vue&type=script&lang=js"
export * from "./LandingGeboortelijst.vue?vue&type=script&lang=js"
import style0 from "./LandingGeboortelijst.vue?vue&type=style&index=0&id=b61b6e38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports